import { defineCommands, defineMarkSpec, union } from "prosekit/core";
import { toggleMark } from "@prosekit/core";

export interface HighlightAttrs {
  color: string | null;
}

export function defineHighlightSpec() {
  return defineMarkSpec<"highlight", HighlightAttrs>({
    name: "highlight",
    parseDOM: [{ tag: "mark" }],
    toDOM: () => {
      return ["mark", 0];
    },
  });
}

export function defineHighlightCommands() {
  return defineCommands({
    toggleHighlight: () => toggleMark({ type: "highlight" }),
  });
}

export function defineHighlight() {
  return union(defineHighlightSpec(), defineHighlightCommands());
}
